import React from "react";

const Loader = () => (
  <div className="mt-[36px] text-center font-medium text-4md">Loading...</div>
);
export default Loader;
